var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterBtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 1V6.25M15.2222 6.25C14.2404 6.25 13.4444 7.03348 13.4444 8C13.4444 8.96652 14.2404 9.75 15.2222 9.75M15.2222 6.25C16.2041 6.25 17 7.03348 17 8C17 8.96652 16.2041 9.75 15.2222 9.75M15.2222 9.75V15M9 1V11.5M9 11.5C8.01813 11.5 7.22222 12.2835 7.22222 13.25C7.22222 14.2165 8.01813 15 9 15C9.98187 15 10.7778 14.2165 10.7778 13.25C10.7778 12.2835 9.98187 11.5 9 11.5ZM2.77778 4.5V15M2.77778 4.5C3.75962 4.5 4.55556 3.7165 4.55556 2.75C4.55556 1.7835 3.75962 1 2.77778 1C1.79594 1 1 1.7835 1 2.75C1 3.7165 1.79594 4.5 2.77778 4.5Z",
    stroke: "#104145",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBtnIcon);
export default __webpack_public_path__ + "static/media/filter-btn-icon.7fbccee97c3636f94f0a6416d27d3056.svg";
export { ForwardRef as ReactComponent };